import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { CopyTextButton } from 'components/CopyTextButton';
import { SHIPMENTS_QUERY_PARAMS } from 'pages/Shipments/params';
import * as React from 'react';
import { Container } from 'types/Watchlist';
import classNames from 'classnames';
import { ClickableCellProps, Column } from './types';

export const OceanBOL: React.FC<ClickableCellProps> = (props) => {
  const container = props.row as Container;

  const { searchParams } = useCustomSearchParams(SHIPMENTS_QUERY_PARAMS);
  const { focusedContainer } = searchParams;

  const isSelected = focusedContainer === container.containerNumber;

  return (
    <div
      className={classNames('p-2 h-full w-full', {
        'border-2 border-blue-900 border-r-0': isSelected,
        'cursor-pointer': !!props.onCellClick,
      })}
      onClick={(e) => {
        e.stopPropagation();
        props.onCellClick?.(container, Column.OceanBol);
      }}
    >
      <div>
        <div className="flex space-x-2">
          <h4 className="uppercase">{container.shipment?.fullBillOfLadingNumber}</h4>
          <CopyTextButton
            value={container.shipment?.fullBillOfLadingNumber || ''}
            label="Copy ocean BOL"
            variant="icon-small"
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        </div>
      </div>
    </div>
  );
};
OceanBOL.displayName = 'Shipments.Table.Cells.OceanBOL';
